class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
       const sampleAtcBtn =document.querySelector('.button.custom-button.sample-atc-btn[data-product-handle="diapers-pants-smaple"]');
             console.log(document.querySelector('.button.custom-button[data-product-handle="diapers-pants-smaple"]'));

      if(sampleAtcBtn){
        // console.log(sampleAtcBtn)
        const selectedSizePill = +document.querySelector(".variant-item.selected").getAttribute("data-variant-id")
        const cartDeletionItem = +event.target.closest(".button.cart-remove-button").getAttribute("data-variant-id")
     if(selectedSizePill == cartDeletionItem){
       sampleAtcBtn.disabled = false;
       sampleAtcBtn.textContent = "Add to Cart"
        sampleAtcBtn.classList.remove("sample-atc-btn");
     }      
        
      }
      const sampleMainProduct = event.target.closest('.cart-item.sample-item.sample-main-item');
      if (sampleMainProduct) {        
        const sampleMainItemKey = sampleMainProduct.dataset.sampleMainItemKey;
        const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
        let mainProductId =
          ".main-product-" + this.getAttribute("main-unique-id");

        let formData = {
          updates: {},
          sections: cartItems.getSectionsToRender().map((section) => section.section),
          section_url: `${window.location.pathname}`,
        };

        var myArray = [];

        // myArray.push(this.getAttribute("data-line-key"));

        let lineItemsToRemove =
          this.closest(".cart-items").querySelectorAll(`.sample-item-${sampleMainItemKey}`);    
              

        lineItemsToRemove.forEach((lineItem) => {
          let lineItemKey = lineItem.getAttribute("data-line-key");
          myArray.push(lineItemKey);
          cartItems.enableLoading(lineItem.querySelector('cart-remove-button').getAttribute("data-index"));
        });
        var variantId;
        for (variantId in myArray) {
          formData["updates"][myArray[variantId]] = 0;
        }
        if (myArray.length > 0) {
          fetch("/cart/update.js", {
            body: JSON.stringify(formData),
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
            },
            method: "POST",
          })
            .then(function (response) {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              
              const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
              const cartDrawerWrapper = document.querySelector("cart-drawer");
              console.log("cartDrawerWrapper",cartDrawerWrapper);

              const cartFooter = document.getElementById("main-cart-footer");
              console.log("cartFooter",cartFooter);

              cartItems.classList.toggle(
                  "is-empty",
                  parsedState.item_count === 0
                );
              if (cartFooter)
                cartFooter.classList.toggle(
                  "is-empty",
                  parsedState.item_count === 0
                );
              if (cartDrawerWrapper)
                cartDrawerWrapper.classList.toggle(
                  "is-empty",
                  parsedState.item_count === 0
                );
              cartItems.getSectionsToRender().forEach((section) => {
                console.log("section",section);
                
                const elementToReplace =
                  document
                    .getElementById(section.id)
                    .querySelector(section.selector) ||
                  document.getElementById(section.id);
                  console.log("elementToReplace",elementToReplace);
                  
                elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              });
              if (cartItems) {
                cartItems.onCartUpdate(); // Refresh cart items
              }
            })
            .catch(function (err) {
              /* uh oh, we have error. */
              console.error(err);
            })
            .finally(() => {
              lineItemsToRemove.forEach((lineItem) => {
              cartItems.enableLoading(lineItem.querySelector('cart-remove-button').getAttribute("data-index"));
              });
            })
        }
      } else {
        const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
        cartItems.updateQuantity(this.dataset.index, 0);
      }


    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
